(function () {
    "use strict";

    angular
        .module("Finance")
        .factory("$language", [
            "tmhDynamicLocale", "$translate", "AvailableLanguages", "$localStorage", "DefaultLanguage", "$activity", "$notification", "$http",
            function(tmhDynamicLocale, $translate, availableLanguages, $localStorage, defaultLanguage, $activity, $notification, $http) {
                var $language = {};

                $language.default = defaultLanguage;
                $language.availableLanguages = availableLanguages;

                $language.get = function() {
                    return $localStorage.language;
                };

                $language.set = function (language) {
                    $localStorage.language = language;
                    tmhDynamicLocale.set(language);
                    $translate.use(language);
                    document.cookie = "Language=" + language;
                };

                var language = $language.get();
                if (typeof language == "undefined") {
                    $activity.start();
                    $http.get("api/language/browser-prefered")
                        .then(function(response) {
                            $activity.finish();
                            for (var i = 0; i < response.data.length; i++) {
                                if ($language.availableLanguages.indexOf(response.data[i].substr(0, 2)) >= 0) {
                                    $language.set(response.data[i].substr(0, 2));
                                    return;
                                }
                            }
                        }, function(response) {
                            $activity.finish();
                            $notification.addError(response.statusText, response);
                        });
                } else {
                    $language.set(language);
                }

                return $language;
            }
        ]);
})();